import assetPath from '/app/xinglets/startpage-logged-out/entry/src/search-inspiration-section/assets/inspire.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')